export default __webpack_public_path__ + "static/media/36I-102797_-15949_0.370fa9ef.jpg";